import { deserialize, serializable } from 'serializr';

export class BillingAddress {
  @serializable
  public addressLine1: string;
  @serializable
  public addressLine2: string;
  @serializable
  public country: string;
  @serializable
  public state: string;
  @serializable
  public city: string;
  @serializable
  public zipCode: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(BillingAddress, input));
  }
}
